/* eslint-disable @reatom/unit-naming-rule */
import BigNumber from 'bignumber.js'

import { Result } from '@blade/std-lib'
import { deviceWalletIdsAtom } from '@root/features/secure-storage/atoms'
import { reatomResource } from '@root/shared/lib'

import { fetchWalletTradeStatsRequestAction } from './wallet-requests'

type Stats = {
  dailyVolumeUsd: BigNumber
  summaryUsd: BigNumber
  topProfit: BigNumber
}

export const walletStatsAtom = reatomResource(async (ctx) => {
  const walletIds = ctx.spy(deviceWalletIdsAtom)

  if (walletIds.size === 0) {
    return Result.succeed(undefined)
  }

  const result = await ctx.schedule(() =>
    fetchWalletTradeStatsRequestAction(ctx, { walletIds: [...walletIds] }),
  )

  return result.pipe(
    Result.map(
      (it): Stats => ({
        dailyVolumeUsd: BigNumber(it.dailyVolumeUsd),
        summaryUsd: BigNumber(it.summaryUsd),
        topProfit: BigNumber(it.topProfit),
      }),
    ),
  )
})
